"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var TableFooter = react_1.forwardRef(function TableFooter(props, ref) {
    return jsx_runtime_1.jsx(core_1.TableFooter, __assign({}, props, { ref: ref }), void 0);
});
exports.default = TableFooter;
//# sourceMappingURL=TableFooter.js.map